import type { ReactNode } from 'react'
import { Symbol, type SymbolName } from './Symbol'

export type ButtonVariante = 'filled' | 'tonal' | 'outlined' | 'text' | 'elevated'

/**
 * Der Knopf der App.
 *
 * ⚠️ `type` ist absichtlich `button`, solange nichts anderes gesagt wird: ein
 * Knopf in einem Formular sendet sonst beim Klick ab. Das ist der häufigste
 * stille Fehler bei selbst gebauten Knöpfen.
 *
 * `laeuft` ist ein Zustand, kein zweiter Knopf: er sperrt und meldet die
 * Arbeit an die Ausgabe (`aria-busy`), damit niemand doppelt abschickt.
 */
export function Button({
  variant = 'filled',
  icon,
  laeuft = false,
  disabled = false,
  type = 'button',
  className,
  children,
  ...rest
}: {
  variant?: ButtonVariante
  icon?: SymbolName
  laeuft?: boolean
  children: ReactNode
} & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'>) {
  return (
    <button
      type={type}
      className={`btn btn--${variant}${className ? ` ${className}` : ''}`}
      disabled={disabled || laeuft}
      {...(laeuft ? { 'aria-busy': true } : {})}
      {...rest}
    >
      {icon ? <Symbol name={icon} className="btn__icon" /> : null}
      <span className="btn__text">{children}</span>
    </button>
  )
}
